import React, { useEffect, useState } from "react";
import axios from "axios";
import { ListGroup, ListGroupItem, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getRootViaTradeId } from "../actions/drugActions";
import DrugForm from "../components/DrugForm";
import Loader from "../components/Loader";
import Meta from "../components/Meta";

const DrugAdminScreen = () => {
  const [searchParams] = useSearchParams();
  const reqTrade = searchParams.get("tradeId");

  const [showButtons, setShowButtons] = useState(true);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const updateServerDrugRoot = async () => {
    setShowButtons(false);
    try {
      await axios.get(`/api/drugs/roots`);
    } catch (error) {
      console.log(error);
    }
  };

  const rootByTradeIdStore = useSelector((state) => state.rootByTradeIdStore);
  const { loading, drug } = rootByTradeIdStore;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userInfo) {
      navigate("/");
    } else if (reqTrade) {
      dispatch(getRootViaTradeId(reqTrade));
    }
  }, [reqTrade, userInfo, navigate, dispatch]);
  return (
    <div>
      <Meta title="Drug Admin Screen" />
      <Tabs>
        <Tabs.Tab eventKey="add" title="Add New Drug">
          {loading ? (
            <Loader />
          ) : drug ? (
            <DrugForm title="UPDATE DRUG DATA" reqTrade={reqTrade} />
          ) : (
            <DrugForm title="ADD NEW DRUG" />
          )}{" "}
        </Tabs.Tab>
        <Tabs.Tab eventKey="manage" title="Manage Drugs">
          <>
            {showButtons && (
              <ListGroup>
                <ListGroupItem className="btn-lg">
                  <div onClick={() => updateServerDrugRoot()}>
                    Update Trade List
                  </div>
                </ListGroupItem>
              </ListGroup>
            )}
          </>
        </Tabs.Tab>
      </Tabs>
    </div>
  );
};
export default DrugAdminScreen;
